



















import { Component, Ref, Vue, Watch } from 'vue-property-decorator';


@Component({
    components: {
        ChoiceFactorRanker: () =>
            import('@/views/Ranker/FactorChoiceViewpointRanker.vue'),
    },
})
export default class RankChoiceDialog extends Vue {
    private dialog: boolean = false;

    // link the dialog open and close to the vuex app module property compareChocieDialog
    // avoid parent child relationship
    // get compareChoiceDialog() {
    //     return appsModule.compareChoiceDialog;
    // }
    // set compareChoiceDialog(val: boolean) {
    //     appsModule.setCompareChoiceDialog(val);
    // }
}
